module.exports = __webpack_public_path__ + "img/getstarted_navigate.0ba81d3c.gif";